import { type PresetStylesClassStructure } from '../types/presetStylesClassStructure';

export const toast = {
  root: ({ props }): PresetStylesClassStructure => ({
    class: [
      //Size and Shape
      'w-96 rounded-md',
      // Positioning
      {
        '-translate-x-2/4': props.position == 'top-center' || props.position == 'bottom-center',
      },
    ],
  }),

  container: ({ props }): PresetStylesClassStructure => ({
    class: [
      'my-4 relative rounded-md w-full',
      'duration-300',
      'border-solid border-0 border-l-[.5rem]',
      'backdrop-blur-[10px] shadow-md',

      // Colors
      {
        'bg-blue-100 ': props.message.severity == 'info',
        'bg-secondaryOffWhite': props.message.severity == 'primary',
        'bg-orange-100 ': props.message.severity == 'warn',
        'bg-green-100': props.message.severity == 'success',
        'bg-red-100': props.message.severity == 'error',
      },

      {
        'border-blue-500 ': props.message.severity == 'info',
        'border-success': props.message.severity == 'success',
        'border-primaryGold': props.message.severity == 'primary',
        'border-error': props.message.severity == 'error',
        'border-orange-500 ': props.message.severity == 'warn',
      },
      {
        'text-blue-700 ': props.message.severity == 'info',
        'text-orange-700': props.message.severity == 'warn',
        'text-primaryGold': props.message.severity == 'primary',
        'text-positive': props.message.severity == 'success',
        'text-negative': props.message.severity == 'error',
      },
    ],
  }),
  content: {
    class: 'flex items-start p-4',
  },
  icon: {
    class: [
      // Sizing and Spacing
      'w-6 h-6',
      'text-lg leading-none mr-2 shrink-0',
    ],
  },
  text: {
    class: [
      // Font and Text
      'text-base leading-none',
      'ml-2',
      'flex-1',
    ],
  },
  summary: {
    class: 'font-bold block ',
  },
  detail: {
    class: 'mt-2 block',
  },
  closebutton: {
    class: [
      // Flexbox
      'flex items-center justify-center',

      // Size
      'w-10 h-10 text-inherit',

      // Spacing and Misc
      'ml-auto  relative',

      // Shape
      'rounded-full',

      // Colors
      'bg-transparent',

      // Transitions
      'transition duration-200 ease-in-out',

      // States
      'hover:bg-surface-0/50 dark:hover:bg-surface-0/10',

      // Misc
      'overflow-hidden',
    ],
  },
  transition: {
    enterFromClass: 'opacity-0 translate-y-2/4 ',
    enterActiveClass: 'transition-[transform,opacity] duration-300',
    leaveFromClass: 'max-h-[1000px]',
    leaveActiveClass:
      '!transition-[max-height_.45s_cubic-bezier(0,1,0,1),opacity_.3s,margin-bottom_.3s] overflow-hidden',
    leaveToClass: 'max-h-0 opacity-0 mb-0',
  },
};
